import moment from 'moment';
import 'moment/locale/ru';
import 'eonasdan-bootstrap-datetimepicker';


let date = document.dateString === '' ? Date.now() : moment(document.dateString, 'YYYY-MM-DD');

let datePicker = $("#archive-datepicker").find("div").datetimepicker({
    inline: true,
    viewMode: 'days',
    format: 'yyyy-MM-dd',
    enabledDates: document.availableDates,
    defaultDate: date,
    locale: 'ru'
});

datePicker.on("dp.change", function (event) {
    location.href = "/news/" + moment(event.date).format('YYYY/MM/DD');
});


// WEBPACK FOOTER //
// ./src/js/newsList.js